import React, {createContext, useContext} from 'react';

/** @import {WithFeatureFlagsProps} from './FeatureFlagsTypes' */

export const FeatureFlagContext = createContext(
  /** @type {string[] | string | null} */ (null)
);

const isEnabled = (/** @type {string[] | string | null} */ context, /** @type {string} */ name) => {
    const features = typeof context === 'string' ? JSON.parse(context) : context;
    return Boolean(features && Array.isArray(features) && features.includes(name));
};

export const useFeatureFlags = () => {
    let ctx = useContext(FeatureFlagContext);
    return [(/** @type {string} */ name) => isEnabled(ctx, name)];
}

/**
 * @template {object} TProps
 **/
const withFeatureFlags = (/** @type {React.ComponentType<TProps & WithFeatureFlagsProps>} */ Component) => {

    return (/** @type {Omit<TProps, keyof WithFeatureFlagsProps>} */ props) => (
        <FeatureFlagContext.Consumer>
            {context => <Component featureEnabled={(/** @type {string} */ name) => isEnabled(context, name)} {.../** @type {TProps} */ (props)} />}
        </FeatureFlagContext.Consumer>
    );
}

export default withFeatureFlags;